import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CustomModal from "components/CustomModal/Modal";
import Snackbar from "components/Snackbar/Snackbar";
import SweetAlert from "react-bootstrap-sweetalert";
import { RotatingLines } from "react-loader-spinner";
import {
  getMakes,
  getModelById,
  saveModel,
  checkModel,
} from "../Services/MakesModelsService";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function EditModel() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();

  const [form, setForm] = useState({
    name: "",
    trim: "",
    year: "",
    vehicle_make_id: "",
    vehicle_type: "",
    surcharge: "",
  });
  const [years, setYears] = useState([]);
  const [makes, setMakes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);
  const [typeToast, setTypeToast] = useState("danger");
  const [alertLoading, setAlertLoading] = useState(null);

  useEffect(() => {
    // Genera los años igual que el PHP
    const currentYear = new Date().getFullYear();
    let yearsArr = [];
    for (let i = -1; i <= 54; i++) {
      yearsArr.push({
        value: `${currentYear - i}`,
        label: `${currentYear - i}`,
      });
    }
    setYears(yearsArr);

    if (id && parseInt(id) > 0) {
      fetchModel(id);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (form.year) {
      fetchMakes(form.year);
    }
    // eslint-disable-next-line
  }, [form.year]);

  const fetchModel = async (modelId) => {
    setLoading(true);
    const result = await dispatch(getModelById({ id: modelId }));
    if (result.payload && result.payload.data) {
      setForm({
        name: result.payload.data.name || "",
        trim: result.payload.data.trim || "",
        year: result.payload.data.year || "",
        vehicle_make_id: result.payload.data.vehicle_make_id || "",
        vehicle_type: result.payload.data.vehicle_type || "",
        surcharge: result.payload.data.surcharge || "",
      });
    }
    setLoading(false);
  };

  const fetchMakes = async (year) => {
    const result = await dispatch(getMakes({ year }));
    if (result.payload && result.payload.data) {
      setMakes(result.payload.data);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBack = () => {
    history.push("/admin/makesModels");
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToastMessage(false);
    loadingAlert();
    // Validación remota como en el PHP
    const check = await dispatch(
      checkModel({
        name: form.name,
        year: form.year,
        vehicleMakeId: form.vehicle_make_id,
        id: id || 0,
      })
    );
    if (check.payload.result && !check.payload.exists) {
      // Guardar
      const result = await dispatch(saveModel({ ...form, id: id || 0 }));
      setAlertLoading(null);
      if (result.payload && result.payload.result) {
        setMessageToast("Model saved successfully.");
        setTypeToast("success");
        setModalSuccess(true);
      } else {
        setMessageToast(result.payload.message || "Error saving model.");
        setTypeToast("danger");
        setToastMessage(true);
      }
    } else {
      setAlertLoading(null);
      setMessageToast(check.payload.message || "Model already exists.");
      setTypeToast("danger");
      setToastMessage(true);
    }
  };

  return (
    <GridContainer
      justifyContent="center"
      alignItems="center"
      xs={12}
      sm={12}
      md={8}
      style={{ margin: "auto" }}
    >
      <Card>
        <CardBody>
          {alertLoading}
          <form onSubmit={handleSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={4}>
                <CustomInput
                  labelText="Model Name"
                  inputProps={{
                    name: "name",
                    value: form.name,
                    onChange: handleInputChange,
                    maxLength: 30,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <CustomInput
                  labelText="Name Trim"
                  inputProps={{
                    name: "trim",
                    value: form.trim,
                    onChange: handleInputChange,
                    maxLength: 10,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <CustomSelect
                  labelText="Year"
                  menuItems={[{ value: "", label: "-- Select --" }, ...years]}
                  inputProps={{
                    name: "year",
                    value: form.year,
                    onChange: handleInputChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <CustomSelect
                  labelText="Make"
                  menuItems={[
                    { value: "", label: "-- Select --" },
                    ...makes.map((make) => ({
                      value: make.id,
                      label: make.name,
                    })),
                  ]}
                  inputProps={{
                    name: "vehicle_make_id",
                    value: form.vehicle_make_id,
                    onChange: handleInputChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <CustomSelect
                  labelText="Vehicle Type"
                  menuItems={[
                    { value: "", label: "-- Select --" },
                    { value: "P", label: "Vehicle" },
                    { value: "M", label: "Motocycle" },
                    { value: "T", label: "Trailer" },
                  ]}
                  inputProps={{
                    name: "vehicle_type",
                    value: form.vehicle_type,
                    onChange: handleInputChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <CustomSelect
                  labelText="Surcharge"
                  menuItems={[
                    { value: "", label: "-- None --" },
                    { value: "Luxury", label: "Luxury" },
                    { value: "High Risk", label: "High Risk" },
                  ]}
                  inputProps={{
                    name: "surcharge",
                    value: form.surcharge,
                    onChange: handleInputChange,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: "20px" }}>
              <GridItem xs={0} sm={0} md={1}></GridItem>
              <GridItem xs={12} sm={6} md={5}>
                <Button
                  variant="default"
                  type="button"
                  onClick={handleBack}
                  block
                >
                  Back
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6} md={5}>
                <Button variant="green" type="submit" block>
                  Save
                </Button>
              </GridItem>
              <GridItem xs={0} sm={0} md={1}></GridItem>
            </GridContainer>
          </form>
          <CustomModal
            title="Success"
            isOpen={modalSuccess}
            onClose={() => history.push("/admin/makesModels")}
            privacy={false}
            id={"successModal"}
          >
            <GridContainer>
              <GridItem xs={12}>
                <span>{messageToast}</span>
              </GridItem>
              <GridItem xs={12}>
                <Button
                  variant="green"
                  onClick={() => history.push("/admin/makesModels")}
                  block
                >
                  Ok
                </Button>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <Snackbar
            style={{ zIndex: "3000" }}
            place="center"
            color={typeToast}
            message={messageToast}
            open={toastMessage}
            closeNotification={() => setToastMessage(false)}
            close
          />
        </CardBody>
      </Card>
    </GridContainer>
  );
}
